export default __webpack_public_path__ + "components/weather-icon/static/nightshowers-2be7c780e98ca090e1baa05c3c18b764.svg";